// NOTE: This is a copy of the function from the `@washpost/zeus-utils` package.
// Once the `@washpost/zeus-utils` package is published into NPM registry, this function should be removed.

const commonModels = {
  contentApi: {
    paths: ["taxonomy.primary_section._id", "taxonomy.primary_site._id"]
  },
  siteService: {
    paths: ["_id"]
  }
};

/**
 * Safely retrieves a value from the object based on the given path strings.
 * @param {Object} data - The object to traverse.
 * @param {String[]} paths - An array of paths to check.
 * @returns {String | null | undefined} - The first valid value found or null/undefined.
 */
function getPrimarySection(data, paths) {
  let anyPathExists = false;

  for (const path of paths) {
    const pathArray = path.split(".");
    let current = data;
    // Track if this specific path exists
    let pathExists = true;

    for (const key of pathArray) {
      if (current && key in current) {
        current = current[key];
      } else {
        pathExists = false;
        current = undefined;
        break;
      }
    }

    if (pathExists) {
      // At least one path exists
      anyPathExists = true;
    }

    // If the value is valid (not null or undefined), return it
    if (current !== null && current !== undefined) {
      return current;
    }
  }

  // If no paths exist at all, return undefined; otherwise, return null
  return anyPathExists ? null : undefined;
}

/**
 * Return the primary_section_id based off of the client's source data calling it.
 * @param {Object | String} data - CAPI Wapo record, or a string. String bypasses everything.
 * @param {String} modelName - The `commonModel` to use for paths.
 * @returns {String | null | undefined} - The `primary_section_id`.
 */
export function getPrimarySectionId(data, modelName) {
  const dataIsString = typeof data === "string";
  if (dataIsString) {
    return data;
  }
  const modelConfig = commonModels[modelName];
  // Check for valid model and paths
  if (!modelConfig || !modelConfig.paths) {
    // Not throwing. Failing gracefully
    console.error(`Invalid model: ${modelName}`);
    // TODO: How to set a misconfiguration from the client?
    return undefined;
  }

  const primarySection = getPrimarySection(data, modelConfig.paths);

  return primarySection;
}
